import { render, staticRenderFns } from "./GoToCartButton.vue?vue&type=template&id=1dbe7aa4&"
import script from "./GoToCartButton.vue?vue&type=script&lang=js&"
export * from "./GoToCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports